// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3Fra2","form":"styles_form__21dho","submit":"styles_submit__2Bwt3","logocontainer":"styles_logocontainer__2mstj"};